module.exports = __webpack_public_path__ + "static/media/JC.dd896801.svg";